import { SyntheticEvent } from 'react';
import configuration from '~/configuration/configuration';

const {
	casino: { tmpGameIcon }
} = configuration;

type ImageError = {
	target: {
		src: string;
		srcset: string;
	};
};

const errorHandler = (e: SyntheticEvent<HTMLImageElement, Event>) => {
	if (e.target instanceof HTMLImageElement) {
		if (tmpGameIcon && tmpGameIcon.src) {
			e.target.src = tmpGameIcon.src;
			e.target.srcset = tmpGameIcon.srcSet;
		} else {
			e.target.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
		}
	}
};

const srcErrorHandler = (e: ImageError) => {
	if (tmpGameIcon && tmpGameIcon.src) {
		e.target.src = tmpGameIcon.src;
	} else {
		e.target.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	}
};

export { errorHandler, srcErrorHandler };
